import _ from 'lodash';

/**
 * Construct the endpoint
 * @param stub
 * @returns {string}
 */
export function buildEndpoint(stub) {
  if (!_.isString(stub)) {
    return '';
  }
  return `${process.env.VUE_APP_KOALABOSS_API}/${stub}`;
}
